/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TapeLibrarySlot
 */
export interface TapeLibrarySlot {
    /**
     * 
     * @type {number}
     * @memberof TapeLibrarySlot
     */
    drive?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TapeLibrarySlot
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof TapeLibrarySlot
     */
    barcode?: string;
    /**
     * 
     * @type {string}
     * @memberof TapeLibrarySlot
     */
    origin?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TapeLibrarySlot
     */
    locked?: boolean;
}

export function TapeLibrarySlotFromJSON(json: any): TapeLibrarySlot {
    return TapeLibrarySlotFromJSONTyped(json, false);
}

export function TapeLibrarySlotFromJSONTyped(json: any, ignoreDiscriminator: boolean): TapeLibrarySlot {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'drive': !exists(json, 'drive') ? undefined : json['drive'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'barcode': !exists(json, 'barcode') ? undefined : json['barcode'],
        'origin': !exists(json, 'origin') ? undefined : json['origin'],
        'locked': !exists(json, 'locked') ? undefined : json['locked'],
    };
}

export function TapeLibrarySlotToJSON(value?: TapeLibrarySlot | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'drive': value.drive,
        'status': value.status,
        'barcode': value.barcode,
        'origin': value.origin,
        'locked': value.locked,
    };
}


